/* eslint-disable react/jsx-props-no-spreading */
import { type FC, type ChangeEvent } from "react";
import { useFormContext } from "react-hook-form";
import * as styles from "./styles.css";

type Props = {
  name: string;
  errorName?: string;
  placeholder: string;
  requiredMessage?: string;
  isError?: boolean;
  isDisabled?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  list: {
    key: string | number;
    value: string | number;
  }[];
};

export const Pulldown: FC<Props> = ({
  name,
  errorName,
  placeholder,
  requiredMessage,
  isError,
  isDisabled,
  onChange,
  list,
}) => {
  const { register, clearErrors, watch } = useFormContext();
  // エラーメッセージの削除
  const deleteErrorMessage = () => {
    if (errorName) {
      // この項目と連動する他のエラーメッセージを削除する場合はerrorNameで指定する
      clearErrors(errorName);
    }
    clearErrors(name);
  };
  const currentValue = watch(name);

  return (
    <select
      className={styles.pulldown({
        isError: !!isError,
        isSelected: !!currentValue,
      })}
      {...register(name, {
        required: requiredMessage,
        disabled: isDisabled,
        onChange: (e: ChangeEvent<HTMLInputElement>) => {
          if (onChange) onChange(e);
          deleteErrorMessage();
        },
      })}
    >
      <option value="">{placeholder}</option>
      {list &&
        list.length > 0 &&
        list.map((item) => (
          <option value={item.value} key={`${item.key}_${item.value}`}>
            {item.key}
          </option>
        ))}
    </select>
  );
};
